import React from 'react'
import Table from '../../components/common/Table'
import { CompetitionResultDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'

interface CompetitionResultTableProps {
  data: CompetitionResultDTO[];
  handleEdit: (row: CompetitionResultDTO) => void;
  handleDelete: (row: CompetitionResultDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const CompetitionResultTable: React.FC<CompetitionResultTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: "Title",
          key: "competitionId",
          render: (row: CompetitionResultDTO) => (
            <span>{row.competition?.name || '-'}</span>
          ),
        },
        {
          label: "Added",
          key: "createdUtc",
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default CompetitionResultTable;
